export type SubscriptionTransport = 'sse' | 'ws';

export function detectSubscriptionTransport(
  forceWebsocketTenants: string[] = [],
  hostname: string = window.location.hostname
): SubscriptionTransport {
  const subdomain = hostname.split('.')[0];
  if (forceWebsocketTenants.includes(subdomain)) {
    return 'ws';
  }
  const nav = performance.getEntriesByType('navigation')[0] as
    | PerformanceNavigationTiming
    | undefined;
  const proto = nav?.nextHopProtocol;
  return proto === 'h2' || proto === 'h3' ? 'sse' : 'ws';
}
